const featureCollection2 = {
  slider: null,
  init: function () {
    this.tabChanged();
  },

  tabChanged: function (event) {
    const self = this;
    const buttons = document.querySelectorAll(".feature-collection-2__tablinks");
    const sliders = document.querySelectorAll(".feature-collection-2 .feature-collection-2__carousel"); // added .feature-collection-2 to make sure it only selects the carousel inside the feature-collection-2
    const tabContent = document.querySelectorAll(".feature-collection-2__tabcontent");

    // Init first slider
    let flkty = new Flickity(sliders[0], {
      cellAlign: "left",
      contain: true,
      // groupCells: true, // Might use this later
      prevNextButtons: true,
      pageDots: true,
    });

    // Set .feature-collection-2's height
    const featureCollection = document.querySelector(".feature-collection-2");
    setTimeout(function () {
      if (featureCollection) featureCollection.style.minHeight = featureCollection.offsetHeight + "px";
    }, 500);

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        sliders.forEach(function (slider) {
          flkty = new Flickity(slider, {
            cellAlign: "left",
            contain: true,
            // groupCells: true, // Might use this later
            prevNextButtons: true,
            pageDots: true,
          });

          // hide slider's parent tab-content before resize
          slider.parentElement.style.opacity = 0;
          slider.parentElement.style.visibility = "hidden";

          flkty.resize();

          // show slider after resize
          setTimeout(function () {
            slider.parentElement.style.opacity = 1;
            slider.parentElement.style.visibility = "visible";
          }, 200);
        });
      });
    });
  },
};

const storeLocator = {
  slider: null,
  init: function () {
    this.tabChanged();
  },

  tabChanged: function (event) {
    const self = this;
    const buttons = document.querySelectorAll(".store-locator__tablinks");
    const sliders = document.querySelectorAll(".store-locator__carousel");
    const tabContent = document.querySelectorAll(".store-locator__tabcontent");

    // Init first slider
    let flkty = new Flickity(sliders[0], {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
    });

    // Set .store-locator's height
    const storeLocator = document.querySelector(".store-locator");
    setTimeout(function () {
      if (storeLocator) storeLocator.style.minHeight = storeLocator.offsetHeight + "px";
    }, 500);

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        sliders.forEach(function (slider) {
          flkty = new Flickity(slider, {
            cellAlign: "left",
            contain: true,
            prevNextButtons: false,
          });

          // hide slider's parent tab-content before resize
          slider.parentElement.style.opacity = 0;
          slider.parentElement.style.visibility = "hidden";

          flkty.resize();

          // show slider after resize
          setTimeout(function () {
            slider.parentElement.style.opacity = 1;
            slider.parentElement.style.visibility = "visible";
          }, 200);
        });
      });
    });
  },
};

const hotspot = {
  hotspotButtonSelector: "[data-hotspot-button]",
  init: function () {
    // Get all the parent elements
    const parents = document.querySelectorAll(".hotspot-content__block");

    // Loop through each parent element
    parents.forEach((parent) => {
      parent.addEventListener("click", () => {
        // Remove active class from other parent siblings children that has .grid-item__content
        parent.parentElement.querySelectorAll(".hotspot-content__block").forEach((child) => {
          child.classList.remove("active");
        });

        // Add active class to the clicked child
        parent.classList.add("active");
      });
    });

    this.onClickHotspotButton();
  },

  onClickHotspotButton: function () {
    const hotspotButton = document.querySelectorAll(this.hotspotButtonSelector);

    hotspotButton.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        const self = event.target;

        // Get data attribute value from the button
        const dataId = self.getAttribute("data-hotspot-target-selector");

        // Get the target element
        const targetElement = document.querySelector(`.${dataId}`);

        // Remove active class from the other siblings
        targetElement.parentElement.querySelectorAll(".hotspot-content__block").forEach((child) => {
          child.classList.remove("active");
        });

        // Add active class to the target element
        targetElement.classList.add("active");
      });
    });
  },
};

/**
 * Chat Support - Trigger conversation app button
 */

const chatSupport = {
  init: function () {
    const btnChat = document.querySelectorAll(".btn-chat");

    btnChat.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();

        // Trigger conversation app button
        const conversationAppIframe = document.getElementById("chat-button");
        GorgiasChat.open();

        // Check if iframe exists
        if (!conversationAppIframe) {
          console.log("----------------------->Conversation app iframe does not exist");
          return;
        }

        return false;
      });
    });
  },
};

/**
 * End of Chat Support - Trigger conversation app button
 */

const upsellProduct = {
  qty: 1,
  init: function () {
    this.onChangeQuantity();
  },

  onChangeQuantity: function () {
    const inputQty = document.querySelectorAll(".upsell-products__qty-num");
    const addQty = document.querySelectorAll(".upsell-products__adjust--plus");
    const minusQty = document.querySelectorAll(".upsell-products__adjust--minus");

    addQty.forEach((qty) => {
      qty.addEventListener("click", (event) => {
        const addToCartParentElement = event.target.parentElement.parentElement.parentElement.parentElement;
        this.qty = addToCartParentElement.querySelector(".upsell-products__qty-num").value;

        this.updateQty(addToCartParentElement);
      });
    });

    minusQty.forEach((qty) => {
      qty.addEventListener("click", (event) => {
        const addToCartParentElement = event.target.parentElement.parentElement.parentElement.parentElement;
        this.qty = addToCartParentElement.querySelector(".upsell-products__qty-num").value;

        this.updateQty(addToCartParentElement);
      });
    });

    inputQty.forEach((qtyInput) => {
      qtyInput.addEventListener("change", (event) => {
        this.qty = event.target.value;
        const addToCartParentElement = qtyInput.parentElement.parentElement.parentElement;

        this.updateQty(addToCartParentElement);
      });
    });
  },

  updateQty: function (parentElement) {
    const addToCartButton = parentElement.querySelector(".js-quick-add-btn");

    // Update product's quantity
    addToCartButton.setAttribute("data-quantity", this.qty);
  },
};

const variantColor = {
  init: function () {
    this.onChangeColor();
  },

  onChangeColor: function () {
    const swatchOption = document.querySelectorAll("[data-color-swatch]");

    swatchOption.forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        const dataId = event.target.getAttribute("data-id");
        const addToCartParentElement = event.target.parentNode.closest("[data-add-to-cart-parent]");
        const addToCartBtn = addToCartParentElement.querySelector("[data-add-to-cart-button]");

        addToCartBtn.setAttribute("data-id", dataId);
      });
    });
  },
};

const deliveryWidget = {
  stockistMapLoaded: false,
  init: function () {
    this.onChangeDelivery();
    this.onSubmitShippingCode();
  },

  loadStockistMap: function () {
    if (this.stockistMapLoaded) return;
    const script = document.createElement("script");
    script.src = "https://stockist.co/embed/v1/widget.min.js";
    document.querySelector("head").appendChild(script);
    this.stockistMapLoaded = true;
  },

  onChangeDelivery: function () {
    const $parent = this;
    const deliveryBtn = $(".delivery__button");

    deliveryBtn.click((event) => {
      event.preventDefault();
      const self = $(event.currentTarget);

      // Get href value
      const href = self.attr("href");
      const contentElement = $(href);

      // Toggle slide contentElement
      contentElement.slideToggle().siblings(".delivery-widget").hide();

      if (href == "#find-store-widget") {
        $parent.loadStockistMap();
      }
    });
  },

  onSubmitShippingCode: function () {
    $("#input_postcode").keypress(function (event) {
      if (event.which === 13) {
        event.preventDefault(); // Prevents the form submission or any default behavior

        $("#search_postcode").click();
      }
    });

    $("[data-input-postcode]").keypress(function (event) {
      if (event.which === 13) {
        event.preventDefault(); // Prevents the form submission or any default behavior
        $(this).parents(".form").find("[data-search-postcode]").click();
      }
    });
  },
};

const header = {
  init: function () {
    this.onToggleSearch();
  },

  onToggleSearch: function () {
    const searchBtn = document.querySelector(".header__search-btn");
    const searchForm = document.querySelector(".header__search-form");

    searchBtn.addEventListener("click", (event) => {
      event.preventDefault();

      searchForm.classList.toggle("active");
    });
  },
};

/*
  addTrackingToForm
  Description: This function runs on `DOMContentLoaded` and first creates a Mutation Observer that does the following:
    1. Gets the different click IDs from the Elevar parameters object
    2. Waits for the `form-embed` component to be added to the document. This is used by the Shopify Forms app to create the popup form.
      2a. `form-embed` is a web component created by Shopify. It operates similarly to an iframe but has some differences. We cannot query the
          form-embed's children directly and must use the Shadow Root element. https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot
    3. Gather the associated input elements for each of the different platform's inputs. These inputs are added to the form in the "Forms" app
    4. For each input found
      4a. Set the associated label as hidden
      4b. Set the input type as hidden
      4c. Set the value of the input to be the associated click ID. If the value is empty it will be empty string
      4d. Dispatch an input event so that the form's state updates. Without this event dispatch the internal form state will not update and the data will not be stored on submit.

    This URL can be used for testing. It will take you to a development page using a development theme with related click IDs added to Elevar
    https://www.remarkablefurniture.com.au/pages?preview_key=ff060972c397f2b7633f17763810882f&preview_theme_id=145821139158&gclid=EAIaIQobChMI_test123&fbclid=IwAR2test456789&ttclid=7WoE3test321&msclkid=12testABC987
 */
const getTrackingIDs = () => {
  const elevarParameters = JSON.parse(localStorage.getItem("___ELEVAR_GTM_SUITE--params")) || {};
  const elevarCookies = JSON.parse(localStorage.getItem("___ELEVAR_GTM_SUITE--cookies")) || {};

  const customerAdIDsArray = ["gclid", "fbclid", "ttclid", "msclkid", "user_id", "session_id"];
  const trackingIds = {};

  const urlParams = new URLSearchParams(window.location.search);
  customerAdIDsArray.map((adID) => {
    trackingIds[adID] = elevarParameters[adID] || urlParams.get(adID) || "";
  });

  trackingIds.client_id = elevarCookies._ga || "";
  trackingIds.uetvisit_id = elevarCookies._uetvid || "";

  return trackingIds;
};
const addTrackingToForm = {
  init: function () {
    // Watch for form-embed element
    const embedObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes) {
          const formEmbed = document.querySelector("form-embed");

          if (formEmbed) {
            // Wait a brief moment for shadow root to be attached if needed
            setTimeout(() => {
              const trackingIds = getTrackingIDs();

              const shadowRoot = formEmbed.shadowRoot;
              if (shadowRoot) {
                function assignValuesToInputs(input, value = "") {
                  input.parentElement.style.display = "none";

                  input.setAttribute("type", "hidden");
                  input.value = value;

                  const inputEvent = new Event("input", { bubbles: true, composed: true });
                  input.dispatchEvent(inputEvent);
                }

                Object.entries(trackingIds).map(([key, value]) => {
                  const input = shadowRoot.getElementById(`custom#${key}`);
                  if (input) {
                    assignValuesToInputs(input, trackingIds[`${key}`]);
                  }
                });
              }
            }, 25);
          }
        }
      }
    });

    // Start watching for form-embed
    embedObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },
};

const addTrackingIDsToNewsletter = {
  init: function () {
    const trackingIds = getTrackingIDs();

    // Add tracking IDs to tags array
    const tagsArray = ["prospect", "newsletter"];
    Object.entries(trackingIds).map(([key, value]) => {
      if (value) {
        tagsArray.push(`${key}:${value}`);
      }
    });

    const tagsInput = document.querySelector('.newsletter-new-section__content input[name="contact[tags]"]');
    if (tagsInput) {
      tagsInput.value = tagsArray.join(",");
    }
  },
};

const addTrackingIDsToClarityZigpoll = {
  init: function () {
    const trackingIds = getTrackingIDs();
    const page_id = window.location.href.toString();
    // Add tracking IDs to clarity, wait for 3 secs to make sure Zigpoll is initialised
    setTimeout(() => {
      if (typeof window.clarity === "function") {
        window.clarity("identify", trackingIds.user_id, trackingIds.session_id, page_id);
        Object.entries(trackingIds).map(([key, value]) => {
          if (value) {
            window.clarity("set", `${key}`, `${value}`);
          }
        });
      } else {
        console.error("Clarity is not initialized.");
      }
    }, 3000);

    // Add tracking IDs to Zigpoll, wait for 3 secs to make sure Zigpoll is initialised
    setTimeout(() => {
      if (window.Zigpoll) {
        window.Zigpoll.user = {
          handle: trackingIds.client_id,
          id: trackingIds.user_id,
          metadata: {
            gclid: trackingIds.gclid,
            fbclid: trackingIds.fbclid,
            uetvisit_id: trackingIds.uetvisit_id,
            msclkid: trackingIds.msclkid,
            session_id: trackingIds.session_id,
          },
        };
        window.Zigpoll.metadata = {
          handle: trackingIds.client_id,
          id: trackingIds.user_id,
          gclid: trackingIds.gclid,
          fbclid: trackingIds.fbclid,
          uetvisit_id: trackingIds.uetvisit_id,
          msclkid: trackingIds.msclkid,
          session_id: trackingIds.session_id,
        };
        console.log(window.Zigpoll.user);
        console.log(window.Zigpoll.metadata);
      } else {
        console.error("Zigpoll is not initialized.");
      }
    }, 3000);
  },
};

document.addEventListener("DOMContentLoaded", function () {
  featureCollection2.init();
  storeLocator.init();
  hotspot.init();
  chatSupport.init();
  upsellProduct.init();
  variantColor.init();
  deliveryWidget.init();
  header.init();

  addTrackingToForm.init();
  addTrackingIDsToNewsletter.init();
  addTrackingIDsToClarityZigpoll.init();
});
